import styled from 'styled-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BasicInput } from '@dev/ee-components';

interface CopyListOrSegmentI {
    onChange(newName: string): void;
    selected: {
        Name?: string;
        rule?: string;
        ListName?: string;
        Error?: boolean;
    };
    isList?: boolean;
}

const DialogContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    .MuiCheckbox-root {
        padding: 4px 9px;
    }
    .MuiInputBase-root {
        margin-bottom: 16px;
    }
`;
export const CopyListOrSegment: FC<CopyListOrSegmentI> = (props: CopyListOrSegmentI): JSX.Element => {
    const { t } = useTranslation();
    const { isList, selected, onChange } = props;
    const defaultName = !isList ? selected.Name : selected.ListName;
    return (
        <DialogContainer>
            <BasicInput
                id="new-list-name-input"
                placeholder={t('listname')}
                defaultValue={defaultName}
                label={!isList ? t('segmentname') : t('listname')}
                onChange={(e): void => {
                    onChange(e.currentTarget.value);
                }}
            />
        </DialogContainer>
    );
};
